export const STATUS_SEM_ATIVIDADE = 0;
export const STATUS_ATIVIDADE_ATRASADA = 1;
export const STATUS_ATIVIDADE_HOJE = 2;
export const STATUS_ATIVIDADE_PLANEJADA = 3;
export const STATUS_ATIVIDADE_CONCLUIDA = 4;

export const COR_STATUS_ATIVIDADE_ATRASADA = "#F44336";
export const COR_STATUS_ATIVIDADE_CONCLUIDA = "#0F9D58 ";
export const COR_STATUS_ATIVIDADE_PLANEJADA = "#457AB7";
export const COR_STATUS_ATIVIDADE_HOJE = "#ED6C02";
export const COR_STATUS_SEM_ATIVIDADE = "#EEE";

export const TIPO_CONTATO = {
  EMAIL: "email",
  TELEFONE: "telefone",
};
